module.exports = __webpack_public_path__ + "png/two_pairs.png?5c2f9c686fb3a7a70988811f6c29e162";